import { render, staticRenderFns } from "./voiceWave.vue?vue&type=template&id=62624cc0&scoped=true"
import script from "./voiceWave.vue?vue&type=script&setup=true&lang=js"
export * from "./voiceWave.vue?vue&type=script&setup=true&lang=js"
import style0 from "./voiceWave.vue?vue&type=style&index=0&id=62624cc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62624cc0",
  null
  
)

export default component.exports